import { BROWSER_MODEL_ID, BROWSER_MODEL_QUALITY_ID } from './browserModel';
import { normalizeAiBaseUrl } from './client';

export type ProviderPreset = 'auto' | 'rules' | 'browser' | 'browserQuality' | 'deepseek' | 'openai' | 'local' | 'custom';

export interface ProviderPresetConfig {
  baseUrl: string;
  model: string;
}

export const providerPresets: Record<ProviderPreset, ProviderPresetConfig> = {
  auto: { baseUrl: 'auto://smart', model: '' },
  rules: { baseUrl: 'rules://builtin', model: '' },
  browser: { baseUrl: 'browser://local', model: BROWSER_MODEL_ID },
  browserQuality: { baseUrl: 'browser://quality', model: BROWSER_MODEL_QUALITY_ID },
  deepseek: { baseUrl: 'https://api.deepseek.com/v1', model: 'deepseek-chat' },
  openai: { baseUrl: 'https://api.openai.com/v1', model: 'gpt-5-mini' },
  local: { baseUrl: 'http://localhost:11434/v1', model: 'qwen3' },
  custom: { baseUrl: 'https://api.example.com/v1', model: '' }
};

export function normalizedTarget(value: string): string {
  try {
    return normalizeAiBaseUrl(value);
  } catch {
    return value.trim();
  }
}

export function fullDestination(value: string): string {
  const target = normalizedTarget(value);
  return target.endsWith('/chat/completions') ? target : `${target}/chat/completions`;
}

export function isLocalTarget(value: string): boolean {
  try {
    return new Set(['localhost', '127.0.0.1']).has(new URL(normalizeAiBaseUrl(value)).hostname);
  } catch {
    return false;
  }
}

export function requiresApiKey(preset: ProviderPreset, baseUrl: string): boolean {
  return !isOfflinePreset(preset) && !isLocalTarget(baseUrl);
}

export function isBrowserModelPreset(preset: ProviderPreset): boolean {
  return preset === 'browser' || preset === 'browserQuality';
}

export function isOfflinePreset(preset: ProviderPreset): boolean {
  return preset === 'auto' || preset === 'rules' || isBrowserModelPreset(preset);
}
